import { getConsumptions, postConsumption, putConsumption } from '../../../Api/services/backoffice';

export const key = 'consumption';

const entityName = {
  singular: 'Consumo',
  plural: 'Consumos',
};

const queries = {
  list: { key, fn: getConsumptions },
  detail: { key },
};

const mutations = {
  create: postConsumption,
  update: putConsumption,
};

const fields = {
  table: [
    { key: 'affiliateTrait.affiliate.name', label: 'Filial' },
    { key: 'affiliateTrait.trait.name', label: 'Traço' },
    { key: 'plusHUGO', label: '+ Hugo' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
